/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  searchResult: [],
  rebateProgram: '',
  rebateProgramList: [],

  selectedPlanType: '',
  isLoading: false,
  planType: [],
  rebateProgramValue: '',
  rebateProgramNameValue: '',
  errors: [],
  fromDateValue: '',
  toDateValue: '',
  displayObj: {
    rebateProgramValue: '',
    rebateProgrameName: '',
    fromDateValue: '',
    toDateValue: '',
    searchResult: [],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };

    case ActionTypes.GET_INTEREST_OVERRIDE_REPORT:
      let displayObj = {
        ...state.displayObj,
        searchResult: action.payload,
      };
      return { ...state, searchResult: action.payload, displayObj };

    case ActionTypes.SET_SELECTED_INPUT:
      return { ...state, ...action.payload };
    case ActionTypes.REFRESH_INTEREST_OVERRIDE:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    case ActionTypes.REFRESH_INTEREST_OVERRIDE_DISPLAY:
      return { ...initialState, displayObj: state.displayObj };
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.isLoading };

    default:
      return state;
  }
};

export default reducer;
